import { Box, useMediaQuery } from '@material-ui/core'
import { useRouter } from 'next/router'
import { Colors, DynamicMuiIcon, Typography } from 'src/components/atoms'
import { useGetLatestAnnouncement } from 'src/fixtures/modules/announcement/hooks'
import theme, { useGlobalStyles } from 'src/styles/theme'

export interface AnnouncementBannerProps {
  title: string
  announcementId: string
}

export const AnnouncementBanner = () => {
  const router = useRouter()
  const { data } = useGetLatestAnnouncement()
  const globalClasses = useGlobalStyles()
  const isSP = useMediaQuery(theme.breakpoints.down('sm'))

  if (!data?.announcement) return null
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height={isSP ? '40px' : '50px'}
      bgcolor={Colors.primary.default}
      color={Colors.functional.whiteText.default}
      p="0px 16px"
      style={{ cursor: 'pointer' }}
      onClick={() => {
        router.push(`/announcements/${data?.announcement?.id}`)
      }}
    >
      <Box>
        <Box display="flex" alignItems="center" mb="0px" style={{ gap: isSP ? '2px' : '8px' }}>
          <DynamicMuiIcon variant="notification" size={isSP ? '20px' : '24px'} />
          <Typography
            style={{
              fontWeight: 'bold',
              whiteSpace: 'pre-wrap',
              fontSize: isSP ? '13px' : '14px'
            }}
            className={globalClasses.lineclamp1}
          >
            {data?.announcement?.title}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
